/* Bounded, consent-gated Bold header-price experiment. Uses shared engagement only. */
(() => {
  'use strict';
  if (window.boldHeaderPriceTest) return;
  window.boldHeaderPriceTest = true;
  const configNode = document.getElementById('BoldHeaderPriceTestConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const params = new URLSearchParams(location.search);
  const preview = String(window.Shopify?.theme?.role) !== 'main' || params.has('preview_theme_id');
  const qa = params.has('ih_telemetry_qa');
  const forced = (preview || qa) && ['control','header'].includes(params.get('ih_header_price_arm')) ? params.get('ih_header_price_arm') : null;
  let arm, enrolled = false, queued = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const active = () => config.enabled && Date.now() >= Date.parse(config.startsAt) && Date.now() < Date.parse(config.endsAt);
  function remove() {
    document.querySelector('[data-header-price-summary]')?.remove();
    document.querySelector('[data-product-layout-header]')?.removeAttribute('data-header-price-test');
  }
  function assign() {
    if (arm) return true;
    if (forced) { arm = forced; return true; }
    if (preview || !active() || !allowed() || !window.InspireEngagement) return false;
    try {
      const key = 'inspire-ihtag-visitor-v1';
      let visitor = localStorage.getItem(key);
      if (!visitor) localStorage.setItem(key, visitor = 'v_' + crypto.randomUUID().replace(/-/g,''));
      let hash = 2166136261;
      for (const char of config.id + ':' + visitor) hash = Math.imul(hash ^ char.charCodeAt(0),16777619) >>> 0;
      arm = hash % 2 ? 'header' : 'control';
      return true;
    } catch { return false; }
  }
  function update() {
    queued = false;
    if (!forced && (!active() || !allowed())) { remove(); arm = undefined; enrolled = false; return; }
    if (!assign()) return;
    const root = document.querySelector('product-info');
    const header = root?.querySelector('[data-product-layout-header]');
    const source = root?.querySelector('[data-bold-price] .npd-price');
    if (!header || !source) return;
    if (!preview && allowed() && window.InspireEngagement && !enrolled) {
      InspireEngagement.track(config.id,'assigned',arm,'',true);
      enrolled = true;
    }
    if (root.dataset.headerPriceArm !== arm) root.dataset.headerPriceArm = arm;
    if (arm === 'control') { remove(); return; }
    let summary = header.querySelector('[data-header-price-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.dataset.headerPriceSummary = '';
      summary.dataset.ihFeature = config.id;
      summary.dataset.ihResource = 'header';
      summary.innerHTML = '<div data-header-selected-size></div><div data-header-selected-price></div>';
      header.append(summary);
      document.dispatchEvent(new CustomEvent('product-info:loaded'));
    }
    if (!header.hasAttribute('data-header-price-test')) header.dataset.headerPriceTest = '';
    const clone = source.cloneNode(true);
    clone.removeAttribute('id');clone.removeAttribute('role');clone.removeAttribute('aria-live');
    clone.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
    const html = clone.innerHTML;
    const target = summary.querySelector('[data-header-selected-price]');
    if (target.innerHTML !== html) target.innerHTML = html;
    const size = root.querySelector('variant-selects select[name*="Size"]')?.value || '';
    const sizeLabel = summary.querySelector('[data-header-selected-size]');
    const text = size ? size + ' selected size' : 'Selected configuration';
    if (sizeLabel.textContent !== text) sizeLabel.textContent = text;
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const root = document.querySelector('product-info');
  if (root) new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
  document.addEventListener('product-info:loaded',schedule);
  document.addEventListener('visitorConsentCollected',()=>{if (!allowed()) { arm=undefined;enrolled=false;remove(); } schedule();});
  let tries=0;
  const timer=setInterval(()=>{schedule();if (++tries>=120 || enrolled || (preview && arm)) clearInterval(timer);},1000);
  schedule();
})();
